
// import React, { useState } from "react";
// import moment from "moment-timezone";
// import Datetime from "react-datetime";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
// import { Col, Row, Card, Form, Button, InputGroup } from '@themesberg/react-bootstrap';


// export const GeneralInfoForm = () => {
//   const [birthday, setBirthday] = useState("");

//   return (
//     <Card border="light" className="bg-white shadow-sm mb-4">
//       <Card.Body>
//         <h5 className="mb-4">Employe create</h5>
//         <Form>
//           <Row>
//             <Col md={6} className="mb-3">
//               <Form.Group id="firstName">
//                 <Form.Label>First Name</Form.Label>
//                 <Form.Control required type="text" placeholder="Enter your first name" />
//               </Form.Group>
//             </Col>
//             <Col md={6} className="mb-3">
//               <Form.Group id="lastName">
//                 <Form.Label>Last Name</Form.Label>
//                 <Form.Control required type="text" placeholder="Also your last name" />
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row className="align-items-center">
//             <Col md={6} className="mb-3">
//               <Form.Group id="birthday">
//                 <Form.Label>Birthday</Form.Label>
//                 <Datetime
//                   timeFormat={false}
//                   onChange={setBirthday}
//                   renderInput={(props, openCalendar) => (
//                     <InputGroup>
//                       <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
//                       <Form.Control
//                         required
//                         type="text"
//                         value={birthday ? moment(birthday).format("MM/DD/YYYY") : ""}
//                         placeholder="mm/dd/yyyy"
//                         onFocus={openCalendar}
//                         onChange={() => { }} />
//                     </InputGroup>
//                   )} />
//               </Form.Group>
//             </Col>
//             <Col md={6} className="mb-3">
//               <Form.Group id="gender">
//                 <Form.Label>Gender</Form.Label>
//                 <Form.Select defaultValue="0">
//                   <option value="0">Gender</option>
//                   <option value="1">Female</option>
//                   <option value="2">Male</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={6} className="mb-3">
//               <Form.Group id="emal">
//                 <Form.Label>Email</Form.Label>
//                 <Form.Control required type="email" placeholder="name@company.com" />
//               </Form.Group>
//             </Col>
//             <Col md={6} className="mb-3">
//               <Form.Group id="phone">
//                 <Form.Label>Phone</Form.Label>
//                 <Form.Control required type="number" placeholder="+12-345 678 910" />
//               </Form.Group>
//             </Col>
//           </Row>

//           <h5 className="my-4">Address</h5>
//           <Row>
//             <Col sm={9} className="mb-3">
//               <Form.Group id="address">
//                 <Form.Label>Address</Form.Label>
//                 <Form.Control required type="text" placeholder="Enter your home address" />
//               </Form.Group>
//             </Col>
//             <Col sm={3} className="mb-3">
//               <Form.Group id="addressNumber">
//                 <Form.Label>Number</Form.Label>
//                 <Form.Control required type="number" placeholder="No." />
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col sm={4} className="mb-3">
//               <Form.Group id="city">
//                 <Form.Label>City</Form.Label>
//                 <Form.Control required type="text" placeholder="City" />
//               </Form.Group>
//             </Col>
//             <Col sm={4} className="mb-3">
//               <Form.Group className="mb-2">
//                 <Form.Label>Select state</Form.Label>
//                 <Form.Select id="state" defaultValue="0">
//                   <option value="0">State</option>
//                   <option value="AP">Andhra Pradesh</option>
//                   <option value="ARP">Arunachal Pradesh</option>
//                   <option value="Ass">Assam</option>
//                   <option value="BI">Bihar</option>
//                   <option value="CHH">Chhattisgarh</option>
//                   <option value="GOA">Goa</option>
//                   <option value="GJ">Gujarat</option>
//                   <option value="HR">Haryana</option>
//                   <option value="HP">Himachal Pradesh</option>
//                   <option value="JR">Jharkhand</option>
//                   <option value="KA">Karnataka</option>
//                   <option value="KE">Kerala</option>
//                   <option value="MP">Madhya Pradesh</option>
//                   <option value="MH">Maharashtra</option>
//                   <option value="MA">Manipur</option>
//                   <option value="ME">Meghalaya</option>
//                   <option value="MI">Mizoram</option>
//                   <option value="NA">Nagaland</option>
//                   <option value="OD">Odisha</option>
//                   <option value="PU">Punjab</option>
//                   <option value="RJ">Rajasthan</option>
//                   <option value="SI">Sikkim</option>
//                   <option value="TN">Tamil Nadu</option>
//                   <option value="TE">Telangana</option>
//                   <option value="TR">Tripura</option>
//                   <option value="UP">Uttar Pradesh</option>
//                   <option value="UK">Uttarakhand</option>
//                   <option value="WB">West Bengal</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col sm={4}>
//               <Form.Group id="zip">
//                 <Form.Label>ZIP</Form.Label>
//                 <Form.Control required type="tel" placeholder="ZIP" />
//               </Form.Group>
//             </Col>
//           </Row>
//           <div className="mt-3">
//             <Button variant="primary" type="submit">Save All</Button>
//           </div>
//         </Form>
//       </Card.Body>
//     </Card>
//   );
// };


// import React, { useState } from "react";
// import axios from "axios";
// import moment from "moment-timezone";
// import Datetime from "react-datetime";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
// import { Col, Row, Card, Form, Button, InputGroup } from '@themesberg/react-bootstrap';

// export const GeneralInfoForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     birthday: "",
//     gender: "0",
//     email: "",
//     phone: "",
//     address: "",
//     addressNumber: "",
//     city: "",
//     state: "0",
//     zip: ""
//   });

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData(prev => ({ ...prev, [id]: value }));
//   };

//   const handleBirthdayChange = (date) => {
//     setFormData(prev => ({ ...prev, birthday: moment(date).format("YYYY-MM-DD") }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post("https://your-api-url.com/submit", formData); // ← Replace with actual API
//       console.log("Response:", response.data);
//       alert("Form submitted successfully!");
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("Failed to submit form.");
//     }
//   };

//   return (
//     <Card border="light" className="bg-white shadow-sm mb-4">
//       <Card.Body>
//         <h5 className="mb-4">Create Employee</h5>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             <Col md={6} className="mb-3">
//               <Form.Group id="firstName">
//                 <Form.Label>First Name</Form.Label>
//                 <Form.Control
//                   type="text"
//                   id="firstName"
//                   value={formData.firstName}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter your first name"
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={6} className="mb-3">
//               <Form.Group id="lastName">
//                 <Form.Label>Last Name</Form.Label>
//                 <Form.Control
//                   type="text"
//                   id="lastName"
//                   value={formData.lastName}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter your last name"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row className="align-items-center">
//             <Col md={6} className="mb-3">
//               <Form.Group id="birthday">
//                 <Form.Label>Birthday</Form.Label>
//                 <Datetime
//                   timeFormat={false}
//                   onChange={handleBirthdayChange}
//                   renderInput={(props, openCalendar) => (
//                     <InputGroup>
//                       <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
//                       <Form.Control
//                         type="text"
//                         value={formData.birthday ? moment(formData.birthday).format("MM/DD/YYYY") : ""}
//                         placeholder="mm/dd/yyyy"
//                         onFocus={openCalendar}
//                         readOnly
//                         required
//                       />
//                     </InputGroup>
//                   )}
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={6} className="mb-3">
//               <Form.Group id="gender">
//                 <Form.Label>Gender</Form.Label>
//                 <Form.Select id="gender" value={formData.gender} onChange={handleChange} required>
//                   <option value="0">Select Gender</option>
//                   <option value="1">Female</option>
//                   <option value="2">Male</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={6} className="mb-3">
//               <Form.Group id="email">
//                 <Form.Label>Email</Form.Label>
//                 <Form.Control
//                   type="email"
//                   id="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                   placeholder="name@company.com"
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={6} className="mb-3">
//               <Form.Group id="phone">
//                 <Form.Label>Phone</Form.Label>
//                 <Form.Control
//                   type="text"
//                   id="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   required
//                   placeholder="+91-1234567890"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <h5 className="my-4">Address</h5>

//           <Row>
//             <Col sm={9} className="mb-3">
//               <Form.Group id="address">
//                 <Form.Label>Address</Form.Label>
//                 <Form.Control
//                   type="text"
//                   id="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   required
//                   placeholder="Enter your home address"
//                 />
//               </Form.Group>
//             </Col>
//             <Col sm={3} className="mb-3">
//               <Form.Group id="addressNumber">
//                 <Form.Label>Number</Form.Label>
//                 <Form.Control
//                   type="text"
//                   id="addressNumber"
//                   value={formData.addressNumber}
//                   onChange={handleChange}
//                   required
//                   placeholder="No."
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             <Col sm={4} className="mb-3">
//               <Form.Group id="city">
//                 <Form.Label>City</Form.Label>
//                 <Form.Control
//                   type="text"
//                   id="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                   placeholder="City"
//                 />
//               </Form.Group>
//             </Col>
//             <Col sm={4} className="mb-3">
//               <Form.Group id="state">
//                 <Form.Label>Select State</Form.Label>
//                 <Form.Select id="state" value={formData.state} onChange={handleChange} required>
//                   <option value="0">State</option>
//                   <option value="AP">Andhra Pradesh</option>
//                   <option value="ARP">Arunachal Pradesh</option>
//                   <option value="Ass">Assam</option>
//                   <option value="BI">Bihar</option>
//                   <option value="CHH">Chhattisgarh</option>
//                   <option value="GOA">Goa</option>
//                   <option value="GJ">Gujarat</option>
//                   <option value="HR">Haryana</option>
//                   <option value="HP">Himachal Pradesh</option>
//                   <option value="JR">Jharkhand</option>
//                   <option value="KA">Karnataka</option>
//                   <option value="KE">Kerala</option>
//                   <option value="MP">Madhya Pradesh</option>
//                   <option value="MH">Maharashtra</option>
//                   <option value="MA">Manipur</option>
//                   <option value="ME">Meghalaya</option>
//                   <option value="MI">Mizoram</option>
//                   <option value="NA">Nagaland</option>
//                   <option value="OD">Odisha</option>
//                   <option value="PU">Punjab</option>
//                   <option value="RJ">Rajasthan</option>
//                   <option value="SI">Sikkim</option>
//                   <option value="TN">Tamil Nadu</option>
//                   <option value="TE">Telangana</option>
//                   <option value="TR">Tripura</option>
//                   <option value="UP">Uttar Pradesh</option>
//                   <option value="UK">Uttarakhand</option>
//                   <option value="WB">West Bengal</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col sm={4} className="mb-3">
//               <Form.Group id="zip">
//                 <Form.Label>ZIP</Form.Label>
//                 <Form.Control
//                   type="text"
//                   id="zip"
//                   value={formData.zip}
//                   onChange={handleChange}
//                   required
//                   placeholder="ZIP"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="mt-3">
//             <Button variant="primary" type="submit">Save All</Button>
//           </div>
//         </Form>
//       </Card.Body>
//     </Card>
//   );
// };




import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, InputGroup } from '@themesberg/react-bootstrap';
import axios from "axios";
import { FormikSearchableSelect } from "./SearchableSelect";

const GENDER_OPTIONS = [
  { value: '1', label: 'Female' },
  { value: '2', label: 'Male' },
];

const STATE_OPTIONS = [
  { value: 'AP', label: 'Andhra Pradesh' },
  { value: 'ARP', label: 'Arunachal Pradesh' },
  { value: 'Ass', label: 'Assam' },
  { value: 'BI', label: 'Bihar' },
  { value: 'CHH', label: 'Chhattisgarh' },
  { value: 'GOA', label: 'Goa' },
  { value: 'GJ', label: 'Gujarat' },
  { value: 'HR', label: 'Haryana' },
  { value: 'HP', label: 'Himachal Pradesh' },
  { value: 'JR', label: 'Jharkhand' },
  { value: 'KA', label: 'Karnataka' },
  { value: 'KE', label: 'Kerala' },
  { value: 'MP', label: 'Madhya Pradesh' },
  { value: 'MH', label: 'Maharashtra' },
  { value: 'MA', label: 'Manipur' },
  { value: 'ME', label: 'Meghalaya' },
  { value: 'MI', label: 'Mizoram' },
  { value: 'NA', label: 'Nagaland' },
  { value: 'OD', label: 'Odisha' },
  { value: 'PU', label: 'Punjab' },
  { value: 'RJ', label: 'Rajasthan' },
  { value: 'SI', label: 'Sikkim' },
  { value: 'TN', label: 'Tamil Nadu' },
  { value: 'TE', label: 'Telangana' },
  { value: 'TR', label: 'Tripura' },
  { value: 'UP', label: 'Uttar Pradesh' },
  { value: 'UK', label: 'Uttarakhand' },
  { value: 'WB', label: 'West Bengal' },
];

export const GeneralInfoForm = () => {
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      birthday: "",
      gender: "0",
      email: "",
      phone: "",
      address: "",
      addressNumber: "",
      city: "",
      state: "0",
      zip: ""
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      birthday: Yup.string().required("Birthday is required"),
      gender: Yup.string().notOneOf(["0"], "Please select gender"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phone: Yup.string().required("Phone is required"),
      address: Yup.string().required("Address is required"),
      addressNumber: Yup.string().required("Address number is required"),
      city: Yup.string().required("City is required"),
      state: Yup.string().notOneOf(["0"], "Please select state"),
      zip: Yup.string().required("ZIP is required")
    }),
    onSubmit: async (values) => {
      try {
        const response = await axios.post("https://your-api-url.com/submit", values);
        alert("Form submitted successfully!");
        console.log(response.data);
      } catch (error) {
        alert("Failed to submit form.");
        console.error(error);
      }
    }
  });

  const handleBirthdayChange = (date) => {
    formik.setFieldValue("birthday", moment(date).format("YYYY-MM-DD"));
  };

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">Add Employee</h5>
        <Form noValidate onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="firstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("firstName")}
                  isInvalid={formik.touched.firstName && formik.errors.firstName}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.firstName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group controlId="lastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("lastName")}
                  isInvalid={formik.touched.lastName && formik.errors.lastName}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.lastName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="birthday">
                <Form.Label>Birthday</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={handleBirthdayChange}
                  renderInput={(props, openCalendar) => (
                    <InputGroup className="has-validation">
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        type="text"
                        value={formik.values.birthday ? moment(formik.values.birthday).format("MM/DD/YYYY") : ""}
                        onFocus={openCalendar}
                        readOnly
                        isInvalid={formik.touched.birthday && formik.errors.birthday}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.birthday}
                      </Form.Control.Feedback>
                    </InputGroup>
                  )}
                />
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group controlId="gender">
                <Form.Label>Gender</Form.Label>
                <FormikSearchableSelect
                  formik={formik}
                  name="gender"
                  options={GENDER_OPTIONS}
                  placeholder="Search gender..."
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  {...formik.getFieldProps("email")}
                  isInvalid={formik.touched.email && formik.errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group controlId="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("phone")}
                  isInvalid={formik.touched.phone && formik.errors.phone}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.phone}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <h5 className="my-4">Address</h5>

          <Row>
            <Col sm={9} className="mb-3">
              <Form.Group controlId="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("address")}
                  isInvalid={formik.touched.address && formik.errors.address}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.address}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col sm={3} className="mb-3">
              <Form.Group controlId="addressNumber">
                <Form.Label>Aadhar Number</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("addressNumber")}
                  isInvalid={formik.touched.addressNumber && formik.errors.addressNumber}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.addressNumber}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={4} className="mb-3">
              <Form.Group controlId="city">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("city")}
                  isInvalid={formik.touched.city && formik.errors.city}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.city}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col sm={4} className="mb-3">
              <Form.Group controlId="state">
                <Form.Label>State</Form.Label>
                <FormikSearchableSelect
                  formik={formik}
                  name="state"
                  options={STATE_OPTIONS}
                  placeholder="Search state..."
                />
              </Form.Group>
            </Col>

            <Col sm={4} className="mb-3">
              <Form.Group controlId="zip">
                <Form.Label>ZIP</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("zip")}
                  isInvalid={formik.touched.zip && formik.errors.zip}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.zip}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <div className="mt-3">
            {/* <Button variant="primary" type="submit">Save All</Button> */}
            <Button variant="primary" type="submit">Save</Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};